module.exports = __webpack_public_path__ + "img/046363_0CC3C3_049B9B_04ACAC-256px.b2bc49a8.png";